<template>
  <div class="login-container" @keyup.enter="login">
    <img :src="pcLogo" alt="logo" :class="{
      'login-logo': VUEAPPWEBSETESIGN === 'ps',
      'login-lt-logo': VUEAPPWEBSETESIGN === 'lt',
    }">
    <div :class="{
      'login-logo-app': VUEAPPWEBSETESIGN === 'ps',
      'login-logo-lt': VUEAPPWEBSETESIGN === 'lt'
    }">
      <img :src="h5Logo" alt="logo" class="logo-app">
    </div>
    <div class="form-box">
      <div class="form-title">{{ $t("auth.logIntoYourAccount") }}</div>
      <el-form @submit.native.prevent ref="form" class="form-container" onclick="return false">
        <div class="va-row">
          <div class="flex md12 w-100">
            <div class="label-title">
              <span class="label-title-text">{{ $t("auth.businessEmail") }}</span>
            </div>
            <div :class="{'has-error': errors.has('Business Email'), 'valid': isFormFieldValid('Business Email')}">
              <!-- data-vv-validate-on="change" -->
              <el-input
                v-model="loginForm.username"
                name="Business Email"
                v-validate="'required|email'"
                required
                data-vv-validate-on="change"
                autocomplete="off"
                class="login-form-input"
                :class="{ 'input-error': errors.first('Business Email') }"
              />
              <small v-show="errors.has('Business Email')" class="help text-danger">
                <div class="d-flex" style="margin-top: 12px;">
                  <img v-if="errors.first('Business Email')" src="@/assets/images/login/attention.svg" alt="" style="margin-right: 6px;">
                  <span>{{ errors.first('Business Email') }}</span>
                </div>
              </small>
            </div>
          </div>
          <div class="flex md12 w-100">
            <div class="label-title d-flex align--end justify--space-between">
              <span class="label-title-text">{{ $t("auth.password") }}</span>
              <span class="forgot-password" @click="forgetPassword">{{ $t("auth.forgotYourPassword") }}</span>
            </div>
            <div :class="{'has-error': errors.has('Password'), 'valid': isFormFieldValid('Password')}" class="password-container">
              <!--  -->
              <el-input
                v-model="loginForm.password"
                name="Password"
                v-validate="'required'"
                required
                autocomplete="off"
                class="login-form-password"
                :type="isOpen ? 'text' : 'password'"
                :class="{ 'input-error': errors.first('Password') }"
              />
              <small v-show="errors.has('Password')" class="help text-danger">
                <div class="d-flex" style="margin-top: 12px;">
                  <img v-if="errors.first('Password')" src="@/assets/images/login/attention.svg" alt="" style="margin-right: 6px;">
                  <span>{{ errors.first('Password') }}</span>
                </div>
              </small>
              <div class="eye-password">
                <img :src="closeEye" alt="" @click="() => { isOpen = true }" v-if="!isOpen" />
                <img :src="openEye" alt="" @click="() => { isOpen = false }" v-if="isOpen" />
              </div>
            </div>
          </div>

          <div class="attempt-remaining" v-if="multipleAttempt">
            <div class="remaining-title">
              <img src="@/assets/images/login/vector.svg" alt="">
              <h5>{{ $t("auth.didYouForgetYourPassword") }}</h5>
            </div>
            <div class="remaining-desc">{{ $t("auth.clickOn") }} <span class="remaining-desc-forgot" @click="forgetPassword">{{ $t("auth.forgotPassword") }}</span> {{ $t("auth.toAvoidBeingLockedOut") }}</div>
          </div>

          <div id="g-recaptcha-container"></div>
          <p class="g-error" v-if="verified && googleRecaptchaFlag">{{ $t("auth.missingRecaptcha") }}</p>

          <div class="flex md12 w-100 form-submit">
            <el-button type="primary" @click="submitForm" :disabled="!(loginForm.username && loginForm.password && errors.items.length === 0)">{{ $t("auth.logIn") }}</el-button>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import qs from "qs";
import { request, consumeShoplazzaLoginRedirect, syncShoplazzaLoginRedirectOnLoginPage } from "@/utils/utils";
import pageName from "../../NewUser/pageNames";
import Spinner from "vue-simple-spinner";
const Base64 = require("js-base64").Base64;

export default {
  name: 'login',
  components: { Spinner },
  data () {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      multipleAttempt: false,
      token: localStorage.getItem("Authorization"),
      permissions: {
        // [pageName.transactions]: false,
        [pageName.report]: false,
        [pageName.appManagement]: false,
        [pageName.finance]: false,
        [pageName.merchantKyc]: false,
        [pageName.userManagement]: false,
        [pageName.wayBill]: false,
        [pageName.virtualAccount]: false,
        [pageName.download]: false,
      },
      closeEye: require('@/assets/images/login/close-eye.svg'),
      openEye: require('@/assets/images/login/open-eye.svg'),
      isOpen: false,
      recaptchaToken: '',
      verified: false
    }
  },
  computed: {
    VUEAPPWEBSETESIGN() {
      return process.env.VUE_APP_WEBSETE_SIGN || ''
    },
    pcLogo() {
      if (process.env.VUE_APP_WEBSETE_SIGN === 'ps') {
        return require(`@/assets/images/psImg/logo-pc.svg`)
      } else {
        return require(`@/assets/images/ltImg/logo-pc.png`)
      }
    },
    h5Logo() {
      if (process.env.VUE_APP_WEBSETE_SIGN === 'ps') {
        return require(`@/assets/images/psImg/logo-app.svg`)
      } else {
        return require(`@/assets/images/ltImg/logo-app.png`)
      }
    },
    googleRecaptchaFlag() {
      return !this.recaptchaToken ? true : false
    }
  },
  methods: {
    ...mapMutations(["changeLogin", "setUser"]),
    login(event) {
      if (event.keyCode === 13 || event.keyCode == 100) {
        this.submitForm();
      }
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
					this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    route() {
      // 仅 Shoplazza（/plugin/auth-bind + state）回跳；否则保持原逻辑进 PaymentOrder
      const redirect = consumeShoplazzaLoginRedirect(this.$route.query);
      if (redirect) {
        this.$router.push(redirect);
      } else {
        this.$router.push({
          name: "PaymentOrder"
        });
      }
      this.$message({
        duration: 1200,
        message: this.$t("auth.loginSuccess"),
        type: "success"
      });
    },
    getUserData() {
      let that = this
      request({
        method: "post",
        url: "api/dashboard/app/user/query?access_token=" + this.token
      })
        .then(response => {
          if (response.data.code == "10000") {
            let isAdmin =
              response.data.data.role === "MERCHANT_ADMIN" ? true : false;
            if (isAdmin) {
              for (let i in that.permissions) {
                that.permissions[i] = true;
              }
              that.permissions[pageName.finance] = response.data.data.show_finance
                ? true
                : false;
              that.permissions[pageName.virtualAccount] = response.data.data.show_virtual_account
                ? true
                : false;
            } else {
              response.data.data.permission.forEach(item => {
                if (that.permissions[item.name] !== undefined) {
                  that.permissions[item.name] =
                    item.privileges[0] === "View" ? true : false;
                }
              });
              if (!response.data.data.show_finance) {
                that.permissions[pageName.finance] = false;
              }
              if (!response.data.data.show_virtual_account) {
                that.permissions[pageName.virtualAccount] = false;
              }
            }

            that.setUser({
              info: response.data,
              permissions: that.permissions
            });
            localStorage.setItem("userInfo", JSON.stringify({
              info: response.data,
              permissions: that.permissions
            }));
            that.route();
          } else {
            that.$message({
              duration: 2000,
              message: "Opps something went wrong!",
              type: "error"
            });
          }
          that.loginLoading.close();
        })
        .catch(err => {
          that.$message({
            duration: 2000,
            message: "Opps something went wrong!",
            type: "error"
          });
          that.loginLoading.close();
        });
    },
    submitFormImpl() {
      this.verified = true
      let username = this.loginForm.username;
      let password = this.loginForm.password;
      if (username === "" || password === "") {
        this.$message({
          message: this.$t("auth.loginFail"),
          type: "error"
        });
      } else {
        if (!this.recaptchaToken) return false;
        localStorage.setItem("startTime", new Date().getTime());
        localStorage.setItem("sessionTime", 1000);
        const that = this;
        that.loadingFullScreen("loginLoading", "Loading...", "fa fa-hourglass-half");
        that.$ajax({
          method: "post",
          // url: "api/dashboard/login",
          url: "api/dashboard/login-booster",
          data: {
            username: username,
            password: password,
            encode: true
          },
          headers: {
            // "Content-Type": "application/x-www-form-urlencoded",
            "Content-Type": "	application/json",
            "g_score": this.recaptchaToken
          }
        }).then(response => {
          that.loginLoading.close();
          const envName = process.env.VUE_APP_NAME.toLowerCase()
          window.$setSessionStorage(`${envName}-reset-gt`, 'reset')
          let code = response.data.code;
          if (code == 10000) {
            let data = response.data.data;
            // 鉴权成功
            if (data.dashboard_redirect) {
              const locationHost = window.location.host
              let query = `?_v=${Base64.encode(0)}&_u=${Base64.encode(username)}&_p=${Base64.encode(password)}`
              if (locationHost === `dashboard-test.${envName}.com` || locationHost === 'localhost:8001') {
                // 测试环境
                let hrefQuery = `https://dashboardv2-dev.${envName}.com/303/${query}`
                window.location.href = hrefQuery
              } else {
                // 生产环境
                let hrefQuery = `https://dashboardv2.${envName}.com/303/${query}`
                window.location.href = hrefQuery
              }
              return
            }

            // if (data.dashboard_redirect_v3) {
            //   localStorage.setItem("dashboard_redirect_v3", true);
            // } else {
            //   localStorage.removeItem("dashboard_redirect_v3");
            // }
            localStorage.removeItem("dashboard_redirect_v3");

            localStorage.setItem("startTime", new Date().getTime());
            if (data.expires_in < 7200) {
              localStorage.setItem("sessionTime", 7200);
            } else {
              localStorage.setItem("sessionTime", data.expires_in);
            }
            localStorage.setItem("refresh_token", data.refresh_token);
            localStorage.setItem("uid", data.uid);
            localStorage.setItem("businessManager", JSON.stringify(data.detail));
            localStorage.setItem("merchantNo", data.detail.merchantNo);
            localStorage.setItem("merchantName", data.merchant_name);
            that.token = data.access_token;
            that.changeLogin({
              Authorization: data.access_token
            });

            // 是否强制密码校验
            let regExpPassword = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*-])[A-Za-z\\d!@#$%^&*-]{8,}$")
            if (!regExpPassword.test(password)) {
              localStorage.setItem("isEasyPassword", true);
            }

            const { detail: { merchants } } = data
            const userData = { merchants }
            localStorage.setItem("userData", JSON.stringify(userData));

            that.getUserData();
          } else if (code == 20002) {
            let data = response.data.data;
            // 返回结果中如果有dashboard_redirect且值是true，跳转到新商户后台 鉴权失败
            if (data && data.dashboard_redirect) {
              const locationHost = window.location.host
              if (locationHost === `dashboard-test.${envName}.com` || locationHost === 'localhost:8001') {
                // 测试环境
                window.location.href = `https://dashboardv2-dev.${envName}.com/forgot-password`
              } else {
                // 生产环境
                window.location.href = `https://dashboardv2.${envName}.com/forgot-password`
              }
              return
            } else {
              // 20002 Bad Credentials 密码错误
              that.$message({
                message: "This password is incorrect. Please try again",
                type: "error"
              });
              that.loginLoading.close();
            }
          } else if (code == 20004) {
            // 20004 Permission Denied Google Recaptha校验失败或者IP限制
            that.$message({
              message: "Browser problems",
              type: "error"
            });
            that.loginLoading.close();
          } else {
            that.$message({
              message: that.$t("auth.loginFail"),
              type: "error"
            });
            that.loginLoading.close();
          }
        }).catch(err => {
          that.loginLoading.close();
          const envName = process.env.VUE_APP_NAME.toLowerCase()
          window.$setSessionStorage(`${envName}-reset-gt`, 'reset')
          that.$message({
            message: "Something unexpected happaned! Please check your network connection!",
            type: "error"
          });
        });
      }
    },
    submitForm () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitFormImpl()
        }
      })
    },
    forgetPassword() {
      this.$router.push({ path: "/resetPassword" });
    },
    replaceGoogleRecaptchaDom() {
      const gRecaptchaDom = document.getElementById('g-recaptcha')
      const gRecaptchaContainerDom = document.getElementById('g-recaptcha-container')
      if (!gRecaptchaDom || !gRecaptchaContainerDom) {
        setTimeout(() => {
          this.replaceGoogleRecaptchaDom()
        }, 300)
        return false;
      }
      gRecaptchaDom.style.display = 'block'
      gRecaptchaContainerDom.appendChild(gRecaptchaDom)
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  },
  components: {
  },
  directives: {
  },
  created() {
    // 非 Shoplazza 入口（无 redirect+state）进入登录页时清残留，避免劫持普通登录
    syncShoplazzaLoginRedirectOnLoginPage(this.$route.query)
    window.addEventListener("setItemEvent", (e) => {
      // console.log('监听----e', e)
      const envName = process.env.VUE_APP_NAME.toLowerCase()
      if (e.key === `${envName}-gr-t`) {
        this.recaptchaToken = e.newValue
        this.verified = false
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.replaceGoogleRecaptchaDom()
    })
  }
}
</script>

<style lang="scss">
.login-container {
  width: 480px;
  height: fit-content;
  .login-logo {
    width: auto;
    height: 32px;
    margin-bottom: 32px;
    display: block;
    /* @include media-breakpoint-down(md) { */
    @media screen and (max-width: 1026px) {
      display: none;
    }
  }
  .login-lt-logo {
    width: 138px;
    height: auto;
    margin-bottom: 32px;
    display: block;
    /* @include media-breakpoint-down(md) { */
    @media screen and (max-width: 1026px) {
      display: none;
    }
  }
  .login-logo-app {
    /* width: 160px;
    height: 48px; */
    margin-bottom: 24px;
    display: none;
    /* @include media-breakpoint-down(md) { */
    @media screen and (max-width: 1026px) {
      background: #FFFFFF3D;
      box-shadow: 0px 4px 4px 0px #0000001F;
      display: block;
      margin-left: 50%;
      transform: translate(-50%, 0);
      padding: 12px 24px;
      border-radius: 90px;
      color: #FFFFFF;
      width: fit-content;
      /* .logo-app {
      } */
    }
  }
  .login-logo-lt {
    margin-bottom: 24px;
    display: none;
    @media screen and (max-width: 1026px) {
      margin-left: 50%;
      transform: translate(-50%, 0);
      display: block;
      width: fit-content;
      .logo-app {
        width: 138px;
        height: auto;
      }
    }
  }
  .form-box {
    background-color: white;
    font-family: SpaceGrotesk-Regular;
    width: 100%;
    height: auto;
    border-radius: 36px;
    border: 1px solid #00000008;
    padding: 36px;
    box-shadow: 0px 0px 12px 0px #00000040;
    .form-title {
      font-size: 24px;
      font-weight: 500;
      line-height: 30px;
      color: #000000;
    }
    .form-container {
      margin-top: 12px;
      .label-title {
        margin-top: 24px;
        margin-bottom: 12px;
        font-weight: 400;
        .label-title-text {
          font-size: 18px;
          line-height: 22px;
          color: #000000;
        }
        .forgot-password {
          font-size: 14px;
          line-height: 18px;
          color: #007D59;
          cursor: pointer;
        }
      }
      .text-danger {
        font-size: 14px;
        color: #BD0000 !important;
      }
      .attempt-remaining {
        font-family: SpaceGrotesk-Regular;
        background: #FF8E3C1F;
        border: 1px solid #FF8E3C;
        border-radius: 12px;
        margin-top: 24px;
        padding: 24px;
        .remaining-title {
          display: flex;
          flex-direction: row;
          align-items: center;
          img {
            width: 18px;
            height: auto;
            margin-right: 12px;
          }
          h5 {
            padding: 0;
            margin: 0;
            font-weight: 500;
            font-size: 18px;
            color: #000000;
          }
        }
        .remaining-desc {
          margin-top: 12px;
          font-weight: 400;
          font-size: 14px;
          color: #000000CC;
          padding-left: 28px;
          .remaining-desc-forgot {
            font-weight: 500;
            color: #000000;
            cursor: pointer;
          }
          .remaining-desc-forgot:hover {
            color: #007D59;
          }
        }
      }

      .form-submit {
        margin-top: 24px;
        button {
          width: 100%;
          height: 48px;
          text-align: center;
          border-radius: 12px;
          border: 1px solid $VUE_APP_COLOR_LOGIN;
          background-color: $VUE_APP_COLOR_LOGIN!important;
          font-weight: 700;
          font-size: 18px;
          letter-spacing: 0.72px;
          color: #FFFFFF;
          outline:none;
        }
        button:focus,
        button:active,
        button:hover {
          border: 1px solid $VUE_APP_COLOR_LOGIN2;
          background-color: $VUE_APP_COLOR_LOGIN2!important;
        }
        button:disabled {
          border: 1px solid $VUE_APP_COLOR_LOGIN;
          background-color: $VUE_APP_COLOR_LOGIN!important;
          color: #FFFFFF99;
        }
      }
      .login-form-input,
      .login-form-password {
        input {
          border-radius: 12px;
          background-color: #FFFFFF;
          border: 1px solid #0000001F;
          font-size: 16px;
          color: #343434;
        }
        input:hover {
          border: 1px solid #0000003D;
        }
        input:active {
          border: 1px solid #007D59;
        }
        input:focus {
          border: 1px solid #0000001F;
        }
      }
      .login-form-password {
        input {
          color: #000000;
        }
      }
      /* .input-error {
        input {
          color: #FF3232DB;
          border: 1px solid #FF32323D;
        }
      } */

      .password-container {
        position: relative;
        .eye-password {
          position: absolute;
          top: 8px;
          right: 12px;
          width: 18px;
          cursor: pointer;
          img {
            width: 100%;
            height: auto;
          }
        }
      }

      #g-recaptcha-container {
        margin-top: 24px;
        /* transform: scale(0.8);
        transform-origin: 0 0; */
      }
      .g-error {
        color: #ea5455;
      }
    }
  }
}

</style>
